import { useCallback, useEffect, useState } from "react";
import { useApi } from "../../api/context";
import { useRealtimeFallbackPolling } from "../../lib/useRealtimeFallbackPolling";
import { useMayUseConsole } from "../console/access";
import { useWorkspace } from "../workspace/WorkspaceContext";

const POLL_MS = 30_000;

/** OWN-317/318: unread console messages (summaries, questions, proposals) for the FAB dot. Owners/admins only. */
export function useAssistantUnread(): { count: number; clear: () => void } {
  const api = useApi();
  const { workspace } = useWorkspace();
  const allowed = useMayUseConsole();
  const [count, setCount] = useState(0);

  const refresh = useCallback(() => {
    if (!allowed) return;
    api.getConsoleUnreadCount(workspace.id).then(setCount, (error: unknown) => {
      console.warn("assistant unread count failed", error);
    });
  }, [allowed, api, workspace.id]);

  useEffect(refresh, [refresh]);
  useRealtimeFallbackPolling(refresh, POLL_MS);
  const clear = useCallback(() => setCount(0), []);
  return { count: allowed ? count : 0, clear };
}
